// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3aTx-","disabled":"FileBtn_disabled__XwAXd","warn":"FileBtn_warn__gzACt","fade":"FileBtn_fade__lK6MZ"};